import { cellRenderPopupActM1 } from '../../PopupActMVP/functionPopupAct';
import {
  cellRenderParseData,
  cellRenderStatusAct,
  cellRenderStorageTimeCount
} from '../../../utils/functions';

const columnDataGridConsignment = [
  {
    dataField: 'documentId',
    caption: 'МХ-1',
    cellRender: cellRenderPopupActM1,
    cssClass: 'td-button-cell-render',
    dataType: 'string'
  },
  {
    dataField: 'mh1Date',
    caption: 'Дата МХ-1',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'mh1NumId',
    caption: 'id МХ-1',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'mh1DocStatus',
    caption: 'id МХ-1 Doc Status',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'storageTimeCount',
    caption: 'Срок хранения',
    dataType: 'number'
  },
  {
    dataField: 'buyoutDate',
    caption: 'Дата выкупа',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'remainingTimeCount',
    caption: 'Осталось времени',
    cellRender: cellRenderStorageTimeCount,
    cssClass: 'td-button-cell-render',
    dataType: 'number'
  },
  {
    dataField: 'mh1DocStatusDescr',
    caption: 'Статус акта МХ-1',
    cellRender: cellRenderStatusAct,
    dataType: 'string'
  },
  {
    dataField: 'internalPieceId',
    caption: 'Внутренний номер УЕ',
    dataType: 'string'
  },
  {
    dataField: 'klPok',
    caption: 'Класс цинкового покрытия',
    dataType: 'string'
  },
  {
    dataField: 'cvet',
    caption: 'Цвет покрытия',
    dataType: 'string'
  },
  {
    dataField: 'departureDate',
    caption: 'Дата убытия баржи',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'cost',
    caption: 'Стоимость',
    dataType: 'number'
  },
  {
    dataField: 'costPerTon',
    caption: 'Стоимость за тонну',
    dataType: 'number'
  }
];

export default columnDataGridConsignment;
